export const formatQuery = (query: string) => {
  return query.replaceAll('\'', '’')
}
